import { setToArray } from '../../utils/lang/sets';
import { ENGINE_MATCHER_WHITELIST } from '../../logger/constants';
export function whitelistMatcherContext(log, ruleAttr) {
    return function whitelistMatcher(runtimeAttr) {
        var isInWhitelist = ruleAttr.has(runtimeAttr);
        log.debug(ENGINE_MATCHER_WHITELIST, [runtimeAttr, setToArray(ruleAttr).join(','), isInWhitelist]);
        return isInWhitelist;
    };
}
